// extracted by mini-css-extract-plugin
module.exports = {"root":"MobileBreadcrumbs_root__jtFaQ"};